module.exports = __webpack_public_path__ + "d4fe7669eed6185ca8943e50b95173fa.pdf";